// @mui
import { useTheme } from '@mui/material/styles';
import { TypographyProps } from '@mui/material';
// hooks
import useResponsive from '../hooks/useResponsive';

// ----------------------------------------------------------------------

export default function GetFontValue(variant: TypographyProps['variant']) {
  const theme = useTheme();

  const breakpoints = useWidth();

  const key = theme.breakpoints.up(breakpoints === 'xl' ? 'lg' : breakpoints);

  // Default to 'body1' if variant is undefined
  const safeVariant = variant || 'body1';

  const hasResponsive =
    safeVariant === 'h1' ||
    safeVariant === 'h2' ||
    safeVariant === 'h3' ||
    safeVariant === 'h4' ||
    safeVariant === 'h5' ||
    safeVariant === 'h6';

  const typographyVariant = (theme.typography as any)[safeVariant];
  const getFont: any =
    hasResponsive && typographyVariant[key]
      ? typographyVariant[key]
      : typographyVariant;

  const fontSize = remToPx(getFont.fontSize);

  const lineHeight = Number(typographyVariant.lineHeight) * fontSize;

  const { fontWeight, letterSpacing } = typographyVariant;

  return { fontSize, lineHeight, fontWeight, letterSpacing };
}

// ----------------------------------------------------------------------

export function remToPx(value: string) {
  return Math.round(parseFloat(value) * 16);
}

export function pxToRem(value: number) {
  return `${value / 16}rem`;
}

export function responsiveFontSizes({ sm, md, lg }: { sm: number; md: number; lg: number }) {
  return {
    '@media (min-width:600px)': {
      fontSize: pxToRem(sm),
    },
    '@media (min-width:900px)': {
      fontSize: pxToRem(md),
    },
    '@media (min-width:1200px)': {
      fontSize: pxToRem(lg),
    },
  };
}

// ----------------------------------------------------------------------

function useWidth() {
  const theme = useTheme();

  const keys = [...theme.breakpoints.keys].reverse();

  return (
    // @ts-ignore not sure what is this
    keys.reduce((output, key) => {
      // eslint-disable-next-line react-hooks/rules-of-hooks
      const matches = useResponsive('up', key);

      return !output && matches ? key : output;
    }, null) || 'xs'
  );
}
